module.exports = __webpack_public_path__ + "static/media/insta_redeem.90a7e299.svg";